import axios from 'axios'

var qs = require('qs');
var root = process.env.API_ROOT


//获取列表数据
export const getListData = (params) => {
  return axios.post(root + '/warehouse/store/list', qs.stringify(params))
}

//存货价值
export const listStockValue = (params) => {
  return axios.post(root + '/warehouse/store/listStockValue', qs.stringify(params))
}

export const initPreMonthStoreMoney = (params) => {
  let config = {
    timeout: 1000 * 60 * 5,
    noloading: true
  };
  return axios.post(root + '/warehouse/store/initPreMonthStoreMoney', qs.stringify(params), config)
}

export const initStockValue = () => {
  return axios.post(root + '/warehouse/store/initStockValue', null)
}

//获取商品列表数据，包含库存
export const getGoodsListWithStore = (params) => {
  return axios.post(root + '/warehouse/store/getgoodslistwithstore', qs.stringify(params))
}
export const getFramelistwithstore = (params) => {
  return axios.post(root + '/warehouse/store/getFramelistwithstore', qs.stringify(params))
}
export const getWholeFramestore = (params) => {
  return axios.post(root + '/warehouse/store/getWholeFramestore', qs.stringify(params))
}

//获取商品列表数据，包含库存预警信息 单个商品的详细清单
export const getGoodsListWithStoreDetail = (params) => {
  return axios.post(root + '/warehouse/store/getGoodsListWithStoreDetail', qs.stringify(params))
}
//
export const getStoreFormList = (params) => {
  return axios.post(root + '/warehouse/store/getStoreFormList', qs.stringify(params))
}
//铺货明细
export const puthuolist = (params) => {
  return axios.post(root + '/warehouse/store/puthuolist', qs.stringify(params))
}

//获取一段时间内的销量
export const goodssalenum = (params) => {
  return axios.post(root + '/warehouse/store/goodssalenum', qs.stringify(params))
}

//需要采购的商品数量（Packagesize,num）
export const getGoodsNeedBuy = (seedcode) => {
  return axios.post(root + '/warehouse/store/getGoodsListWithStoreDetail', qs.stringify(seedcode))
}


//获取某商品的二维库存表
export const getDataBySeedCodeAndCagKuCodes = (params) => {
  return axios.post(root + '/warehouse/store/getdatabyseedcodeandcagkucodes', qs.stringify(params))
}


//获取工厂明细
export const getDetail = (params) => {
  return axios.get(root + '/warehouse/store/detail', {params: params})
}


//删除行
export const deleteData = (params) => {
  return axios.post(root + '/warehouse/store/remove', qs.stringify(params))
}

//保存某一行的数据
export const saveData = (params) => {
  if (params.unitguid) {//修改

    return axios.post(root + '/warehouse/store/update', qs.stringify(params))
  } else {//添加
    return axios.post(root + '/warehouse/store/save', qs.stringify(params))
  }
}
//生成出库单
export const saveOutboundData = (params) => {
  return axios.post(root + '/warehouse/store/saveOutbound', qs.stringify(params))

}


//插入库存商品
export const saveStorageSeeds = (params) => {
  return axios.post(root + '/warehouse/store/save', qs.stringify(params))
}


//导入库存数据
export const upExcel = (params) => {
  return axios.post(root + '/warehouse/store/upExcel', qs.stringify(params))
}

//导入库存数据(数量选择)
export const bacthUpExcel = (params) => {
  return axios.post(root + '/warehouse/store/bacthUpExcel', qs.stringify(params))
}
export const upExcelYinxin= (params) => {
  return axios.post(root + '/warehouse/store/upExcelYinxin', qs.stringify(params))
}
//待发货
export const stayDelivar = (params) => {
  return axios.post(root + '/warehouse/store/stayDelivar', qs.stringify(params))
}
export const stayTransfernumMap = (params) => {
  return axios.post(root + '/warehouse/store/stayTransfernumMap', qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/set/jxcresultstore.js